import { paginationFragment } from './fragments/pagination';

export const lotWorksSettingsFragment = `
  frontage {
    min
    max
  }
  buildpocket {
    min
    max
  }
  minLotPrice
  lotIds
`;

const fragment = `
  id
  name
  description
  beds
  baths
  garages
  sizeSqft
  basePrice
  imageUrl
  defaultImageUrl
  tourUrl
  hashId
  status
  openTourUrlInOverlayWindow
  externalId
  lotWorksSettings {
    ${lotWorksSettingsFragment}
  }
  minLotPrice
  uTourUrl
  communities {
    id
    name
    imageUrl
    phases {
      id
      phase
    }
  }
  productType {
    id
    name
  }
  elevations {
    id
    name
    description
    isDefault
    imageUrl
  }
  specifications {
    id
    name
  }
  palettes {
    id
    name
    description
    defaultImageUrl
    images {
      id
      isDefault
      imageUrl
      palette {
        id
        name
      }
    }
  }
  modelPackages {
    id
    isDefault
    package {
      id
      name
      description
      imageUrl
      basePrice
    }
  }
  floors {
    id
    name
    imageUrl
    size
    bedrooms
    bathrooms
    isBelowGrade
    floorGroups {
      id
      name
      enableMultipleSelection
      floorOptions {
        id
        name
        imageUrl
        priceChange
        sizeChange
        bedsChange
        bathsChange
        garagesChange
        description
        alternateImageUrl
        alternateOption
        isDefault
        imagesCount
        priceRulesCount
        lotWorksSettings
        availabilityRule
        availabilityCommunities
        availabilityCommunityPhases
        defaultCommunities
        dependencies {
          group
          operator
          values
        }
        isAutoSelectedByDefault
        applyFloorPlanHighlight
      }
    }
  }
  floorPlanProvider
  focus360Settings {
    floorPlanCode
    floorPlanSysId
  }
  lastModifiedLog {
    id
    initialValue
    finalValue
    maker {
      id
      name
      role
    }
  }
  creator {
    id
    name
    role
  }
`;

const liteFragment = `
  id
  name
  imageUrl
  basePrice
`;

export const listModelsQuery = `
  query ListModels(
    $filter: ModelFilterInput
    $sort: SortInput
    $page: Int
    $pageSize: Int
  ) {
    result: listModels(filter: $filter, sort: $sort, page: $page, pageSize: $pageSize) {
      items {
        ${fragment}
      }
      pagination {
        ${paginationFragment}
      }
    }
  }
`;

export const listModelsLiteQuery = `
  query ListModelsLite(
    $filter: ModelFilterInput
    $sort: SortInput
    $page: Int
    $pageSize: Int
  ) {
    result: listModels(filter: $filter, sort: $sort, page: $page, pageSize: $pageSize) {
      items {
        ${liteFragment}
      }
      pagination {
        ${paginationFragment}
      }
    }
  }
`;

export const getModelQuery = `
  query GetModel($id: Int!) {
    item: getModel(id: $id) {
      ${fragment}
    }
  }
`;

export const createModelQuery = `
  mutation CreateModel(
    $input: CreateModelInput!
    $image: Upload
  ) {
    item: createModel(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const updateModelQuery = `
  mutation UpdateModel(
    $input: UpdateModelInput!
    $image: Upload
  ) {
    item: updateModel(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const deleteModelQuery = `
  mutation DeleteModel(
    $id: Int!
  ) {
    item: deleteModel(id: $id) {
      ${fragment}
    }
  }
`;

export const setModelPalettesQuery = `
  mutation SetModelPalettes(
    $input: SetModelPalettesInput!
  ) {
    item: setModelPalettes(input: $input) {
      id
    }
  }
`;

export const setModelCommunitiesQuery = `
  mutation SetModelCommunities(
    $input: SetModelCommunitiesInput!
  ) {
    item: setModelCommunities(input: $input) {
      id
    }
  }
`;

export const cloneModelQuery = `
  mutation CloneModel($id: Int!) {
    item: cloneModel(id: $id) {
      ${fragment}
    }
  }
`;
